
<div class="fr-ended-container" *ngIf="isFundraiserEnded">
  <div class="fr-ended-successfully" *ngIf="isSuccessfullyFunded">
    <div class="fr-ended-title">YOU MADE IT POSSIBLE !</div>
    <div class="fr-ended-desc">
      {{fundraiser?.campaigner?.full_name}} has successfully raised funds & reached the goal amount.
      We thank all the {{fundraiser?.raised?.backers}} generous supporters for their kindness.
    </div>
    <div class="shares-wrapper">
    <app-fb-share class="fr-ended-share" backgroudColor="#ffffff" color="#3b5998"
                  label="Inspire with this story" [count]="fundraiser?.fb_share_count">
    </app-fb-share>
    <app-whatsapp-share *ngIf="basicInfo?.social" class="fr-ended-share" backgroudColor="#ffffff"
                        color="#128c7e" label="Share via Whatsapp" [count]="sharedCounts"
                        [basicInfo]="basicInfo" [fundraiser]="fundraiser" [isFundraiserEnded]="isFundraiserEnded">
    </app-whatsapp-share>
  </div>
  </div>
  <div class="fr-ended" *ngIf="!isSuccessfullyFunded">
    <img class="alert" loading="lazy" data-src="/assets/images/Sip-banner-people/group.png" alt="Alert" />
    <span class="fdr-ended"> <strong>Fundraiser Ended! </strong></span>
    <span class="fdr-ended-date" *ngIf="fundraiser?.end_date">This fundraiser ended on {{fundraiser?.end_date | dayjs:'format':'MMMM Do, YYYY'}}</span>
  </div>
</div>
